(ns shared.core.components.forms.views
  (:require [shared.core.components.button :as button]
            [shared.core.components.h :as h]
            [shared.core.components.checkbox :as checkbox]
            [shared.core.components.dropdown :as dropdown]
            [shared.core.components.input :as input]
            [shared.core.form]
            [shared.core.reactive :as re]
            [shared.core.style :as style]
            [clojure.string :as s]
            [shared.core.components.theme :as theme]
            [shared.core.util :as util]))

(defn form-field [{:keys [kind container-style]
                   :or {kind :input}
                   :as args}]
  [:div {:style (merge {:flex 1} container-style)}
   [(condp = kind
      :input input/input
      :textarea input/textarea
      :json-textarea input/json-textarea
      :json-textarea-with-schema input/json-textarea-with-schema
      :checkbox checkbox/checkbox
      :checkbox-group checkbox/checkbox-group
      :dropdown dropdown/dropdown)
    (dissoc args :kind :container-style)]])

(defn form-buttons [{:keys [fields form-path on-cancel on-save style extra-disabled-checks cancel-text save-text]
                     :or {cancel-text "Cancel"
                          save-text "Save"}}]
  (let [form @(re/subscribe [:form/form- form-path])]
    (when (or on-cancel on-save)
      [:div {:style (merge {:display :flex
                            :align-items :center}
                           style)}
       (when on-cancel
         [button/white-button {:style (cond-> {:flex 1}
                                              on-save (assoc :margin-right 5))
                               :on-click on-cancel}
          cancel-text])
       (when on-save
         [button/green-button {:style (cond-> {:flex 1}
                                              on-cancel (assoc :margin-left 5))
                               :on-click #(on-save form)
                               :loading? (:mutating? form)
                               :disabled? (or (some (fn [{:keys [required? form-name required-check
                                                                 kind allowed-keys schema]
                                                          :or {required-check #(and (not (s/blank? %))
                                                                                    (not (false? %)))}}]
                                                      (let [v (get form form-name)]
                                                        (or (and required? (not (required-check v)))
                                                            (and (or (= :json-textarea kind)
                                                                     (= :json-textarea-with-schema kind))
                                                                 (not (s/blank? v))
                                                                 (cond
                                                                   schema (util/valid-json-with-schema? v schema)
                                                                   allowed-keys (not (util/valid-json-keys? v allowed-keys))
                                                                   :else (not (util/valid-json? v)))))))
                                                    (flatten fields))
                                              (some #(not (true? %)) extra-disabled-checks))}
          save-text])])))

(defn form [{:keys [form-path header sub-header fields match-label-placeholder? row-style style] :as args}]
  [:div {:style (merge {:width "100%"} style)}
   (when (not (s/blank? header))
     [h/h2 {:style {:text-align :center}} header])
   (when (not (s/blank? sub-header))
     [theme/theme
      :div {:style {:color (style/color :gray :base)
                    :font-size 16
                    :text-align :center
                    :margin-top 5}
            :theme (style/dark-style {:color (style/dark-color :on-background :darker-1)})}
      sub-header])
   (into [:div {:style {:display :flex
                        :flex-direction :column
                        :margin-top 10
                        :width "100%"}}]
         (->> (filterv identity fields)
              (mapv (fn [row-fields]
                      (let [rf (if (map? row-fields) [row-fields] (filterv identity row-fields))]
                        (when (not-empty rf)
                          (into [:div {:style (merge {:display :flex
                                                      :align-items :center
                                                      :margin-top 10
                                                      :width "100%"}
                                                     row-style)}]
                                (map-indexed (fn [idx f]
                                               (if (map? f)
                                                 [form-field (assoc f :label (if match-label-placeholder?
                                                                               (or (:label f) (:placeholder f))
                                                                               (:label f))
                                                                      :placeholder (if match-label-placeholder?
                                                                                     (or (:placeholder f)
                                                                                         (when (string? (:label f))
                                                                                           (:label f)))
                                                                                     (:placeholder f))
                                                                      :form-path (or (:form-path f) form-path)
                                                                      :container-style (merge (when (not= idx 0)
                                                                                                {:margin-left 10})
                                                                                              (:container-style f)))]
                                                 (filterv identity f)))
                                             rf))))))
              (filterv identity)))
   [form-buttons (assoc args :style {:margin-top 20})]])
